/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuDto } from '../../models/menu-dto';

export interface MenuGetMenuById$Plain$Params {
  menuId: string;
}

export function menuGetMenuById$Plain(http: HttpClient, rootUrl: string, params: MenuGetMenuById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
  const rb = new RequestBuilder(rootUrl, menuGetMenuById$Plain.PATH, 'get');
  if (params) {
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuDto>;
    })
  );
}

menuGetMenuById$Plain.PATH = '/api/Menu/{menuId}';
